import { gsap } from 'gsap/dist/gsap';

export const ANIMATION_DURATION = 0.4;

export function createEasedTimeline(): gsap.core.Timeline & { run: () => gsap.core.Tween } {
  const timeline = gsap.timeline({ paused: true });
  timeline.run = () =>
    gsap.to(timeline, {
      time: timeline.duration(),
      duration: timeline.duration(),
      ease: 'power1.inOut',
    });
  return timeline as gsap.core.Timeline & { run: () => gsap.core.Tween };
}
